module.exports = __webpack_public_path__ + "static/media/card-battlerun.afd2c9ff.png";